
// import router from "../router/index";
// import store from "../store";
import BaseApi from "./BaseApi";

export default class DeliveryLetterService extends BaseApi {


    constructor(){
        super();
    }


    async list(business, filter)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/delivery-letters${filter}`)
        .catch(this.handleErrorResponse);
    }


    async get(business, id)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/delivery-letters/${id}`)
        .catch(this.handleErrorResponse);
    }

    async store(business, data)
    {
        return this.http.post(`${this.baseUrl}/business/${business}/delivery-letters`, data)
        .catch(this.handleErrorResponse);
    }



    async update(business, id, data)
    {
        return this.http.put(`${this.baseUrl}/business/${business}/delivery-letters/${id}`, data)
        .catch(this.handleErrorResponse);
    }


    async delete(business, id)
    {
        return this.http.delete(`${this.baseUrl}/business/${business}/delivery-letters/${id}`)
        .catch(this.handleErrorResponse);
    }


    async pdf(business, id)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/delivery-letters/${id}/pdf`,
        {
            responseType: "blob",
            headers:  { "Access-Control-Allow-Origin": "*" },
            exposedHeaders: ["Content-Disposition"],
        })
        .catch(this.handleErrorResponse);
    }


    exportDeliveryLetters(business)
    {
        return this.http.get(`${this.baseUrl}/business/${business}/delivery-letters/export`,
        {
            responseType: "blob",
            headers:  { "Access-Control-Allow-Origin": "*" },
            exposedHeaders: ["Content-Disposition"],
        })
        .catch(this.handleErrorResponse);
    }
}